import { useEffect, useState } from 'react';
import '../../../../../assets/css/providercustomers.css';
import '../../../../../assets/css/bookings.css';
import '../../../../../assets/css/filter.css';
import '../../../../../assets/css/tables.css';
import '../../../../../assets/css/providerreviews.css';
import '../../../../../assets/css/pointOfInterests.css';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import PaginationController from '../../../common/pagination_controller/PaginationController';
import SimpleLoader from '../../../common/SimpleLoader';
import SortOptionsSelector from '../../../common/sort_options/SortOptionsSelector';
import { getPointOfInterests } from './networking';
import PointOfInterestItems from './PointOfInterestItems';
// import ViewTypeSelector from '../../../common/ViewTypeSelector';
import jsondata from './dummyData.json'
import PoisCrudForm from './PoisForms/PoisCrudForm';
import IconButton from "../../atom/IconButton";
import uploadIcon from "../../../../../assets/icons/UploadIcon.svg";
import downloadIcon from "../../../../../assets/icons/ic_download.svg";
import {getPoisToMatchFile, uploadMatchedPoisFile} from "../provider_applications/networking";
import FileHelper from "../../../../../utilities/helpers/FileHelper";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UploadMatchedPoisDialog from "./UploadMatchedPoisDialog";
import { useHistory } from 'react-router-dom';
import {NavigatorPaths} from "../../../../../assets/dictionaries/NavigatorPaths";
import {showToast} from "../../../../../utilities/helpers/ToastHelper";
import SearchLocation from "../../resale_hub/components/SearchLocation";

const PointOfInterests = () =>{
    const dictionary = useDictionary();
	const history = useHistory();
    const [pointOfInterests,setPointOfInterests] = useState([]);
    const [pageSize, setPageSize] = useState(
		parseInt(localStorage.getItem('pointOfInterests_selected_page_size') ?? 10)
	);
	const [selectedOption, setSelectedOption] = useState(localStorage.getItem('pointOfInterests_selected_sort_type') ? JSON.parse(localStorage.getItem('pointOfInterests_selected_sort_type')) : {value: 'created_at', direction: 'desc', label: 'Newest'});
	const [currentPage, setCurrentPage] = useState(0);
	const [dataLength, setDataLength] = useState(0);
	const [totalPoisToMatch, setTotalPoisToMatch] = useState(0);
	const [showLoader, setShowLoader] = useState(true);
	const [showPoiInfo, setShowPoiInfo] = useState(false);
	const [groupPoiType, setGroupPoiType] = useState(null);
	const [editId, setEditId] = useState('');
	const [showPoisToMatchBtnDialog, setShowPoisToMatchBtnDialog] = useState(false);
	const [showPoisMatchedBtnDialog, setShowPoisMatchedBtnDialog] = useState(false);
	const [showUploadMatchedPoisDialog, setUploadMatchedPoisDialog] = useState(false);
	const [searchParam, setSearchParam] = useState('');

    const columnsConfig = {
		[dictionary.Poi_Input]: { fixed: false, visible: true },
		[dictionary.Poi_Search_Input]: { fixed: false, visible: true },
		[dictionary.Poi_Place_Id]: { fixed: false, visible: true },
		[dictionary.Poi_Name]: { fixed: false, visible: true },
		[dictionary.Poi_PBM]: { fixed: false, visible: true },
		[dictionary.Poi_OBM]: { fixed: false, visible: true },
		[dictionary.Poi_Location_Type]: { fixed: false, visible: true },
		[dictionary.Poi_Matched]: { fixed: false, visible: true },
		[dictionary.Poi_Status]: { fixed: false, visible: true },
		[dictionary.Poi_Iteration]: { fixed: false, visible: true },
		[dictionary.Poi_Parsed_At]: { fixed: false, visible: true },
		[dictionary.Poi_Force_Update]: { fixed: false, visible: true },
		[dictionary.Poi_Place_Status]: { fixed: false, visible: true },
	};

    const getPointOfInterestsAsync = async () => {
		setShowLoader(true);
		try {
			const {data} = await getPointOfInterests(selectedOption,pageSize,currentPage,searchParam);
			setPointOfInterests(data.data);
			setDataLength(data.recordsFiltered ?? data?.recordsTotal ?? 0);
			setTotalPoisToMatch(data.total_pois_to_match);
			setShowLoader(false);
		} catch (error) {
			setShowLoader(false);
			console.error('Error fetching pointOfInterests:', error);
		}
    }

	const onSortOptionValueChanged = (option) => {
		if(option.value !== selectedOption.value){
			setSelectedOption(option);
		}
	};

    useEffect(()=>{
		setShowLoader(true);
        getPointOfInterestsAsync();
    },[pageSize, currentPage, selectedOption, searchParam])

    const onPagingParameterChanged = (type, newParameter) => {
		if (type === 'page') {
			setCurrentPage(newParameter);
		} else if (type === 'page-size') {
			setPageSize(newParameter);
		}
	};

	const createNewPoi = () => {
		// TODO: Implement create new point of interest logic
		setGroupPoiType('create');
		setShowPoiInfo(true);
	}

	const onEditClicked = (id) => {
		setEditId(id);
		setGroupPoiType('edit');
		setShowPoiInfo(true);
	};

	const poiSaveEvent = async () => {
		setEditId('');
		setGroupPoiType(null);
		setShowPoiInfo(false);
		getPointOfInterestsAsync();
		//Fetch Data again Here
	};

	const handleShowPoisMatchedFileDialog = () => {
		setShowPoisMatchedBtnDialog(true);
		setUploadMatchedPoisDialog(true);
		setShowPoisMatchedBtnDialog(false);
	};
	
	const handleUploadPoisMatchedFile = async (file, iteration) => {
	  if(!file){
		  showToast({
			  type: 'error',
			  message: dictionary.upload_mathcer_pois_error_empty_file,
			  position: 'bottom-left',
			  className: 'toast-white-error'
		  });
		  return;
	  }
		setUploadMatchedPoisDialog(false);
		setShowLoader(true);

		try {
			await uploadMatchedPoisFile(file, iteration);
			showToast({
				type: 'success',
				message: dictionary.success_uploaded,
			});
			getPointOfInterestsAsync();
		} catch (error) {
			let errorMessage = dictionary.upload_mathcer_pois_server_error;
			if(error.response.data.message){
				errorMessage += error.response.data.message;
			}
			showToast({
				type: 'error',
				message: errorMessage,
				position: 'bottom-left',
				className: 'toast-white-error'
			});
		} finally {
			setShowLoader(false);
		}
	}

	const handleDownloadPoisToMatchFile = async () => {
		try {
			setShowPoisToMatchBtnDialog(true);
			const response = await getPoisToMatchFile();
			FileHelper.downloadFile(response);
		} catch (error) {
			showToast({
				type: 'error',
				message: dictionary.point_of_interests_no_file,
				position: 'bottom-left',
				className: 'toast-white-error'
			});
		} finally {
			setShowPoisToMatchBtnDialog(false);
		}
	};

	const onPoiClicked = (item) => {
		try {
			history.push(`/${NavigatorPaths.point_of_interests.path}/${item.id}`);
		} catch (error) {
			console.error("Navigation error:", error);
		}
	};

	const onSearchValueChanged = (value) => {
		if (value && value !== searchParam) {
			//updateCurrentPage(0);
		}
		setSearchParam(value);
	}

    return (
        <div
			className="provider-customers-container provider-review-container poi-container"
			style={{
				background: 'var(--background-color)',
				paddingTop: '0'
			}}
		>
			<div className="booking-header-container provider-customers-header-container desktop">
				<h2 className="title-main">
					{dictionary.PointOfInterests}
				</h2>
				<div>
					{/*<div*/}
					{/*	onClick={createNewPoi}*/}
					{/*	className={`button provider-create-button`}*/}
					{/*>*/}
					{/*	<div className="plus-icon" />*/}
					{/*		{dictionary.add_new_poi}*/}
					{/*</div>*/}
                </div>
				<div className="flex-filler" />
				<div className="experiences-filter booking-exp-admin-filter">
					<SearchLocation onValueChanged={onSearchValueChanged} />
					<IconButton
						onClickIcon={handleDownloadPoisToMatchFile}
						activeState={showPoisToMatchBtnDialog}>
						<div className="experiences-filter-box">
							<img className="icon-filter" src={downloadIcon} />
							<span style={{maxWidth:'fit-content'}}>
								{dictionary.download_pois_to_match} ({totalPoisToMatch})
							</span>
						</div>
					</IconButton>
					<IconButton onClickIcon={handleShowPoisMatchedFileDialog} activeState={showPoisMatchedBtnDialog}>
						<div className="experiences-filter-box">
							<img className="icon-filter" src={uploadIcon} />
							<span style={{maxWidth:'fit-content'}}>
								{dictionary.upload_matched_pois}
							</span>
						</div>
					</IconButton>
				</div>
				<div className='wrappper_sortoptions'>
					<SortOptionsSelector
						onValueChanged={onSortOptionValueChanged}
						name={'pointOfInterests'}
					/>
				</div>
			</div>
			<div className="booking-header-container provider-customers-header-container mobile">
				<h2 className="title-main">
					{dictionary.PointOfInterests}
				</h2>
				<div className='d-flex justify-between' style={{width:'100%'}}>
					<div>
						{/*<div*/}
						{/*	onClick={createNewPoi}*/}
						{/*	className={`button provider-create-button`}*/}
						{/*>*/}
						{/*	<div className="plus-icon" />*/}
						{/*		{dictionary.add_new_poi}*/}
						{/*</div>*/}
					</div>
					<div className="flex-filler" />
					<div className='wrappper_sortoptions'>
						<SortOptionsSelector
							onValueChanged={onSortOptionValueChanged}
							name={'pointOfInterests'}
						/>
					</div>
				</div>
			</div>
			{pointOfInterests?.length === 0 ? (
				<div
					className="empty-provider-customers-list-wrapper d-flex-center"
					style={{ height: '80%' }}
				>
					<div className="empty-provider-customers-list-placeholder d-flex-center">
						<div className="empty-provider-customers-image" />
						<h3
							data-testid="no-bookings-yet-header"
							className='empty-provider-customers-title'
						>
							{dictionary.point_of_interests_empty_message}
						</h3>
						<div className="text empty-provider-customers-message">
							{dictionary.point_of_interests_empty_description}
						</div>
					</div>
				</div>
			) : null}
                <div className="upiria-table-container booking-table-container">
                    <div className="upiria-table-header-strip" />
                    <div className="upiria-table-container-inner thin-scrollbar">
                        <table
                            cellSpacing="0"
                            cellPadding="0"
                            border="0"
                            className="upiria-table-container-point-of-interests-table"
                        >
                            <thead>
                            <tr>
                                {
                                    Object.keys(columnsConfig).map(
                                        (col) => columnsConfig[col].visible && <th key={col}>{col}</th>
                                    )
                                }
                            </tr>
                            </thead>
                            <tbody>
                                {pointOfInterests?.map((item) => (
                                    <PointOfInterestItems
                                        key={item.id}
                                        item={item}
										onEditClicked={onEditClicked}
										onPoiClicked={onPoiClicked}
										// onDeleteClicked={onDeleteClicked}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            <PaginationController
				name="pointOfInterests"
				onParameterChanged={onPagingParameterChanged}
				dataLength={dataLength}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			{showUploadMatchedPoisDialog && (
				<UploadMatchedPoisDialog onFileUpload={handleUploadPoisMatchedFile} setUploadVisibility={setUploadMatchedPoisDialog}/>
			)}
			{showPoiInfo ? (
				<PoisCrudForm
					type={groupPoiType}
					showDialog={showPoiInfo}
					setShowDialog={setShowPoiInfo}
					poiSaveEvent={poiSaveEvent}
					editId={editId}
				/>
			) : null}
			{showLoader ? <SimpleLoader showLoader={showLoader} /> : null}
			<ToastContainer />
        </div>
    )
}

export default PointOfInterests;